import { useState } from "react";
import { Loader2, MailCheck } from "lucide-react";
import { Input } from "@/components/ui/input";
import { PageShell, Section } from "@/components/PageShell";

export default function RecoverAccess() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("idle"); // idle | loading | done

  const submit = async (e) => {
    e.preventDefault();
    setStatus("loading");
    try {
      await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/support/resend-access`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });
    } catch (err) {
      /* generic response regardless */
    }
    setStatus("done");
  };

  return (
    <PageShell
      title="Recover Access"
      subtitle="Lost your access link? Enter the email you purchased with and we will resend it."
      testid="recover-access-page"
    >
      <Section>
        {status === "done" ? (
          <div className="flex items-start gap-3 rounded-2xl border border-[#F5A623]/30 bg-[#14213D] px-5 py-4" data-testid="recover-done">
            <MailCheck className="mt-0.5 h-5 w-5 flex-shrink-0 text-[#F5A623]" />
            <p className="text-[15px] leading-relaxed text-[#BFD4E8]">
              If an order exists for that email, your access instructions are on
              the way. Please check your inbox and spam folder.
            </p>
          </div>
        ) : (
          <form onSubmit={submit} className="max-w-[440px] space-y-4">
            <label htmlFor="recover-email" className="sr-only">Email address</label>
            <Input
              id="recover-email"
              type="email"
              autoFocus
              placeholder="name@email.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="recover-email-input"
              className="h-12 border-white/15 bg-[#14213D] text-base text-white placeholder:text-[#6E829B]"
            />
            <button
              type="submit"
              disabled={status === "loading"}
              data-testid="recover-submit-button"
              className="inline-flex w-full items-center justify-center gap-2 rounded-xl bg-[#F5A623] py-3.5 font-heading text-base font-bold text-[#0B132B] transition-transform duration-200 hover:-translate-y-0.5 disabled:opacity-70"
            >
              {status === "loading" ? <Loader2 className="h-5 w-5 animate-spin" /> : "Resend my access link"}
            </button>
          </form>
        )}
      </Section>
    </PageShell>
  );
}
